import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatRadioModule } from '@angular/material/radio'
import { Router, RouterModule } from '@angular/router'
import { TranslationService } from '../../../services/translation.service'
import { ProductTemplateListComponent } from './product-template-list/product-template-list.component'

@Component({
  selector: 'app-product-csv-templates',
  imports: [
    RouterModule,
    MatExpansionModule,
    MatRadioModule,
    ProductTemplateListComponent,
  ],
  templateUrl: './product-csv-templates.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-csv-templates.component.scss',
})
export class ProductCsvTemplatesComponent {
  translationService = inject(TranslationService)
  router = inject(Router)

  goToCreate() {
    this.router.navigate(['settings', 'product-csv-templates'])
  }
}
